import React, { useEffect, useState, useMemo } from 'react';
import { getdata, updatedata, formatdate } from "../../util/global";
import PrescriptionTable from './PrescriptionTable';
import PrescriptionForm from './PrescriptionForm';
import PrescriptionView from './PrescriptionView';


const Prescription = () => {
  const [prescriptiondata, setprescriptiondata] = useState([]);
  const [patientdata, setpatientdata] = useState([]);
  
  const [searchquery, setsearchquery] = useState("");
  const [mode, setmode] = useState(false);

  const [formdata, setformdata] = useState({ name: "", phonenumber: "",
    datetime: formatdate(new Date()),
    medicinedata: [{ medicine: "", dosage: "", instructions: "" }],
    notes: "", _id: null });


  const fetchdata = async () => {
    try {
      const pdata = await getdata({ filter: { datatype: "prescriptiondata", access: [{_userid:window.APPUSER?.user?.userid}] } });
      setprescriptiondata( pdata.reverse());
      const patdata = await getdata({ filter: { datatype: "patientdata", _userid: window.APPUSER?.user?.userid } });
      setpatientdata(patdata);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { 
    fetchdata(); 
  }, []);

  const filteredprescriptions = useMemo(() => {
    return prescriptiondata.filter(p => 
      p.name?.toLowerCase().includes(searchquery.toLowerCase()) || 
      p.medicine?.toLowerCase().includes(searchquery.toLowerCase())
    );
  }, [prescriptiondata, searchquery]);

  const openedit = (type, item) => {
    setformdata({ ...item, _id: item._id });
    setmode("edit" + type );
  };

  const openview = (type, item) => {
    setformdata({ ...item, _id: item._id });
    setmode("view" + type );
  };

  const handlesubmit = async () => {
    let patient = patientdata.find(item => item.phonenumber == formdata.phonenumber);
    let patientpayload = {data: {name:formdata.name, phonenumber:formdata.phonenumber, datatype:"patientdata", _userid: window.APPUSER?.user?.userid}};

    if (patient) {
      patientpayload.data._id = patient._id;
    }

    let patientid = await updatedata(patientpayload);
    formdata._patientid = patientid[0].id;

    const payload = { data: { ...formdata, datatype: "prescriptiondata", _userid: window.APPUSER?.user?.userid } };

    let prescriptionid = await updatedata(payload);
    formdata._id = prescriptionid[0].id;
    await fetchdata();
    
    openview("prescription", formdata);
  };

  return (
    <div className="content-area">
      <div className="table-header-row">
        <h1 className="dash-title">Prescriptions</h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input 
            type="text" 
            placeholder="search name or medicine..." 
            className="form-input" 
            style={{ width: '250px' }}
            value={searchquery}
            onChange={(e) => setsearchquery(e.target.value)}
          />
         
        </div>
      </div>

      <PrescriptionTable data={filteredprescriptions} openedit={openedit} openview={openview} />
      

      <PrescriptionView 
        mode={mode} 
        setmode={setmode} 
        formdata={formdata} 
        patientdata={patientdata}
        prescriptiondata={prescriptiondata}
      />
      
    </div>
  );
};

export default Prescription;